<template>
  <div>
    <title>商品列表</title>
    <section class="goodsBox">
        <!--S 检索-->
        <el-form :model="searchGLForm" inline class="searchForm">
            <el-form-item label="出库时间">
                <!-- S 双日期选择器 -->
                <TwoDatePicker
                    @twoDateObtain="outDateReceive"
                    :startvaldate="searchGLForm.outTime.length>0?searchGLForm.outTime[0]:''"
                    :endvaldate="searchGLForm.outTime.length>0?searchGLForm.outTime[1]:''"
                    key="out">
                </TwoDatePicker>
                <!-- E 双日期选择器 -->
            </el-form-item>
            <el-form-item label="激活时间">
                <!-- S 双日期选择器 -->
                <TwoDatePicker
                    @twoDateObtain="actDateReceive"
                    :startvaldate="searchGLForm.actTime.length>0?searchGLForm.actTime[0]:''"
                    :endvaldate="searchGLForm.actTime.length>0?searchGLForm.actTime[1]:''"
                    key="act">
                </TwoDatePicker>
                <!-- E 双日期选择器 -->
            </el-form-item>
            <el-form-item label="券卡过期时间" class="allWidth">
                <el-date-picker
                    v-model="searchGLForm.startTermTime"
                    type="date"
                    placeholder="选择日期"
                    :picker-options="{}"
                ></el-date-picker>
                <em>至</em>
                <el-date-picker
                    v-model="searchGLForm.endTermTime"
                    type="date"
                    placeholder="选择日期"
                    :picker-options="{}"
                ></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="querySubmit">查询</el-button>
                <el-button type="primary" plain @click="$router.back(-1)">返回</el-button>
                <em class="simpleSearch" style="cursor: pointer;" @click="highShow = !highShow">{{highShow?'精简筛选':'高级筛选'}}</em>
            </el-form-item>
            <div class="none" :class="{'block':highShow}">
                <el-form-item label="期望发货日期">
                    <!-- S 双日期选择器 -->
                    <TwoDatePicker
                        @twoDateObtain="expectDateReceive"
                        :startvaldate="searchGLForm.expectTime.length>0?searchGLForm.expectTime[0]:''"
                        :endvaldate="searchGLForm.expectTime.length>0?searchGLForm.expectTime[1]:''"
                        key="expectTime">
                    </TwoDatePicker>
                    <!-- E 双日期选择器 -->
                </el-form-item>
                <el-form-item label="发货日期">
                    <!-- S 双日期选择器 -->
                    <TwoDatePicker
                        @twoDateObtain="deliverDateReceive"
                        :startvaldate="searchGLForm.deliverTime.length>0?searchGLForm.deliverTime[0]:''"
                        :endvaldate="searchGLForm.deliverTime.length>0?searchGLForm.deliverTime[1]:''"
                        key="deliverTime">
                    </TwoDatePicker>
                    <!-- E 双日期选择器 -->
                </el-form-item>
                <el-form-item label="下单时间">
                    <!-- S 双日期选择器 -->
                    <TwoDatePicker
                        @twoDateObtain="orderDateReceive"
                        :startvaldate="searchGLForm.orderTime.length>0?searchGLForm.orderTime[0]:''"
                        :endvaldate="searchGLForm.orderTime.length>0?searchGLForm.orderTime[1]:''"
                        key="orderTime">
                    </TwoDatePicker>
                    <!-- E 双日期选择器 -->
                </el-form-item>
                <el-form-item label="序列号段" class="serialInput">
                    <el-input v-model="searchGLForm.startSerial" clearable maxlength="20" placeholder="请输入开始序列号"></el-input>
                    <small>~</small>
                    <el-input v-model="searchGLForm.endSerial" clearable maxlength="20" placeholder="请输入结束序列号"></el-input>
                </el-form-item>
                <el-form-item label="券卡编码" class="codeSerIpt">
                    <el-input v-model="searchGLForm.cardCode" placeholder="请输入券卡编码" clearable maxlength="20"></el-input>
                </el-form-item>
                <el-form-item label="手机号码">
                    <el-input v-model="searchGLForm.phone" placeholder="请输入手机号" clearable maxlength="16"></el-input>
                </el-form-item>
                <el-form-item label="券卡状态">
                    <CardState :isState="searchGLForm.cardState" @cardStateObtain="cardStateObtain" :type="1"></CardState>
                </el-form-item>
                <el-form-item label="券卡类型">
                    <el-autocomplete
                        v-model="searchGLForm.cardType"
                        :fetch-suggestions="querySearchAsync"
                        placeholder="请输入券卡类型"
                        :maxlength="25"
                    >
                    </el-autocomplete>
                </el-form-item>
                <el-form-item label="门店券卡流向">
                    <el-select v-model="searchGLForm.flowcode" popper-class="scrollSelect" filterable clearable placeholder="请选择或输入" :filter-method="filterFlow" @focus="closeFlowName">
                      <div class="optionBox">
                        <el-option
                            v-for="item in flowList"
                            :key="item.membercode"
                            :label="item.membername"
                            :value="item.membercode">
                        </el-option>
                      </div>
                      <el-pagination
                          @current-change="flowCurrentChange"
                          :current-page="flowCurrent"
                          :page-sizes="[30]"
                          :page-size="30"
                          layout="pager"
                          :total="flowBean.totalnum" v-show="flowBean.totalnum"
                          small>
                      </el-pagination>
                    </el-select>
                </el-form-item>
                <el-form-item label="定义类型">
                    <DefineType :isDefine="searchGLForm.defineType" @defineTypeObtain="defineTypeObtain"></DefineType>
                </el-form-item>
                <el-form-item label="由流向方发货">
                    <el-select v-model="searchGLForm.bbindflowsend" filterable placeholder="请选择或输入" clearable>
                        <el-option label="是" value="1"></el-option>
                        <el-option label="否" value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="只可到店提货">
                    <el-select v-model="searchGLForm.isbindstore" filterable placeholder="请选择或输入" clearable>
                        <el-option label="是" :value="1"></el-option>
                        <el-option label="否" :value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="订单来源">
                    <OrderSource :isOrderSource="searchGLForm.prosource" @orderSourceObtain="orderSourceObtain"></OrderSource>
                </el-form-item>
                <!-- <el-form-item label="订单状态"> -->
                    <OrderState :isOstate="searchGLForm.ordstate" @orderStatusObtain="orderStatusObtain" :type="1"></OrderState>
                <!-- </el-form-item> -->
                <el-form-item label="提货终端">
                    <el-select v-model="searchGLForm.terminaltype" filterable placeholder="请选择或输入" clearable>
                        <el-option label="PC" :value="0"></el-option>
                        <el-option label="手机" :value="1"></el-option>
                        <el-option label="微信" :value="2"></el-option>
                    </el-select>
                </el-form-item>
                <template v-if="ElementControls('giftCardToMallCoin')==1">
                    <el-form-item label="是否支持兑换商城币">
                        <el-select v-model="searchGLForm.supportshopcurrency" filterable placeholder="请选择或输入" clearable>
                            <el-option label="是" :value="1"></el-option>
                            <el-option label="否" :value="0"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="实际用途">
                        <el-select v-model="searchGLForm.realusefor" filterable placeholder="请选择或输入" clearable>
                            <el-option label="券卡提货" :value="0"></el-option>
                            <el-option label="兑换商城币" :value="1"></el-option>
                        </el-select>
                    </el-form-item>
                </template>
                <!-- <el-form-item label="订单归属">
                    <el-select v-model="searchGLForm.operpower" filterable placeholder="请选择或输入" clearable>
                        <el-option label="总部" :value="0"></el-option>
                        <el-option label="门店" :value="1"></el-option>
                        <el-option label="发货网点" :value="2"></el-option>
                        <el-option label="分销商" :value="3"></el-option>
                    </el-select>
                </el-form-item> -->
                <el-form-item label="券卡类别">
                    <el-select v-model="searchGLForm.cardcategory" filterable placeholder="请选择或输入" clearable>
                        <el-option label="定量组合提货卡" :value="0"></el-option>
                        <el-option label="套餐组合提货卡" :value="1"></el-option>
                        <el-option label="定额组合提货卡" :value="2"></el-option>
                    </el-select>
                </el-form-item>
            </div>
        </el-form>
        <!--E 检索-->
        <!-- 注意：有合并表头样式的table，这里要加类名borderIndiv -->
        <div class="gsListTable individualiz borderIndiv">
            <el-form :model="searchGLForm" inline size="medium">
                <el-form-item class="borderline">
                    <em class="greyColor">券卡介质</em>
                    <el-checkbox-group v-model="searchGLForm.cardMedium" @change="mediumUpdate">
                        <el-checkbox :label="0">实体券卡</el-checkbox>
                        <el-checkbox :label="1">电子券卡</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item class="borderline">
                    <em class="greyColor">送货方式</em>
                    <el-checkbox-group v-model="searchGLForm.delimode" @change="delimodeUpdate">
                        <el-checkbox :label="0">自提</el-checkbox>
                        <el-checkbox :label="1">送货</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" plain @click="specMange = true" v-show="!exportShow">任务列表</el-button>
                    <el-button type="primary" plain @click="groupShow = true" v-show="!exportShow">归类统计</el-button>
                    <el-button type="primary" plain v-show="!exportShow" @click="openExport">导出</el-button>
                    <el-button type="success" v-show="exportShow" icon="el-icon-check" round @click="toPrinting(0)">检索导出</el-button>
                    <el-button type="success" v-show="exportShow" icon="el-icon-check" round @click="toPrinting(1)">勾选导出</el-button>
                    <el-button type="danger" v-show="exportShow" icon="el-icon-close" round @click="closeExport">取消</el-button>
                </el-form-item>
            </el-form>
            <!--S 列表-->
            <!-- 注意：有合并表头样式的table要加类名borderTable -->
            <el-table ref="gsTable" class="gsTable comTable borderTable" border :data="cardStatisticsList" :maxHeight="tableHeight" @selection-change="handleSelectionChange" v-loading="loading">
                <el-table-column v-if="exportShow" type="selection" width="80" fixed></el-table-column>
                <el-table-column type="index" label="序号" fixed></el-table-column>
                <el-table-column label="券卡编码" min-width="290" fixed>
                    <template slot-scope="scope">
                      <p :title="scope.row.code+`${scope.row.serial?('【'+scope.row.serial+'】'):''}`">{{scope.row.code}}<b v-show="scope.row.serial">【{{scope.row.serial}}】</b></p>
                    </template>
                </el-table-column>
                <el-table-column label="手机号码" min-width="160">
                    <template slot-scope="scope">
                      <p :title="scope.row.phone">{{scope.row.phone | empty}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="券卡状态" min-width="120">
                    <template slot-scope="scope">
                        <p class="textHiden" :class="{
                            'orangeColor':scope.row.stateName == '未激活' || scope.row.stateName == '未提货'||scope.row.stateName == '部分提货',
                            'greenColor': scope.row.stateName == '已提货',
                            'greyColor': scope.row.stateName!='未激活'&&scope.row.stateName!='未提货'&&scope.row.stateName!='部分提货'&&scope.row.stateName!='已提货'
                        }">{{scope.row.stateName}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="券卡用途" min-width="120">
                    <template slot-scope="scope">
                        <p class="textHiden">{{scope.row.carduseName}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="券卡介质" min-width="120">
                    <template slot-scope="scope">
                        <p class="textHiden" :class="{'orangeColor':scope.row.cardmediumName == '电子券卡', 'blueColor': scope.row.cardmediumName == '实体券卡'}">{{scope.row.cardmediumName}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="券卡类型" min-width="120">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.cardkind">{{scope.row.cardkind?scope.row.cardkind:'未设置'}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="使用次数" min-width="120">
                    <template slot-scope="scope">
                        {{scope.row.usenum}}
                    </template>
                </el-table-column>
                <el-table-column label="剩余次数" min-width="120">
                    <template slot-scope="scope">
                        {{scope.row.residuenum}}
                    </template>
                </el-table-column>
                <el-table-column label="可选商品数量" min-width="150">
                    <template slot-scope="scope">
                        <span v-if="scope.row.cardcategory === 0 || scope.row.cardcategory === 1 || scope.row.cardcategory === 2" class="cursorHand iconhand" @click="viewMoreCard(scope.row)">{{scope.row.selnum}}</span>
                        <span v-else>{{scope.row.selnum}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="默认商品" min-width="300">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.defaultgoodsname">{{scope.row.defaultgoodsname | empty}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="可选专区/商品" min-width="150">
                    <template slot-scope="scope">
                        <a href="javascript:;" @click="seeGoodsInfo(scope.row.code)" tag="p" class="hand iconhand" v-if="scope.row.defaultgoodscode || scope.row.optgoodsuid">共{{scope.row.selzones?scope.row.selzones:1}}个可选专区</a>
                        <p class="textHiden" v-else>
                            无可选专区
                        </p>
                    </template>
                </el-table-column>
                <el-table-column label="最新兑换商品" min-width="300">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.actgoodsname">{{scope.row.actgoodsname | empty}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="券卡面值(￥)" min-width="150">
                    <template slot-scope="scope">{{scope.row.cardprice | empty}}</template>
                </el-table-column>
                <el-table-column label="总部售价(￥)" min-width="150">
                    <template slot-scope="scope">{{scope.row.cardsmallprice | empty}}</template>
                </el-table-column>
                <el-table-column label="门店售价(￥)" min-width="150">
                    <template slot-scope="scope">{{scope.row.lcardsmallprice | empty}}</template>
                </el-table-column>
                <!-- <el-table-column label="二级分销售价(￥)" min-width="180">
                    <template slot-scope="scope">{{scope.row.tcardsmallprice?scope.row.tcardsmallprice:'--'}}</template>
                </el-table-column> -->
                <el-table-column label="付款状态" min-width="180">
                    <template slot-scope="scope">
                        <p  :class="{
                            'redColor':scope.row.paystatusName == '待付款',
                            'greenColor': scope.row.paystatusName == '部分付款',
                            'greyColor': scope.row.paystatusName=='部分退款'||scope.row.paystatusName=='全部退款'||scope.row.paystatusName=='无需退款',
                            'blueColor': scope.row.paystatusName=='已付款'
                            }">{{scope.row.paystatusName}}</p>
                        <small v-show="scope.row.paydate">{{scope.row.paydate}}</small>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="付款时间" min-width="120">
                    <template slot-scope="scope">
                        <p class="textHiden">{{scope.row.paydate}}</p>
                    </template>
                </el-table-column> -->
                <el-table-column label="定义类型" min-width="150">
                    <template slot-scope="scope">
                        <span :title="scope.row.deftypeName">{{scope.row.deftypeName | empty}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="门店券卡流向" min-width="150">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.lflowname">{{scope.row.lflowname | empty}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="有效期" min-width="180" align="center" header-align="center">
                    <template slot-scope="scope">
                      <div class="center" v-if="scope.row.allvaldate.indexOf('-')!=-1">
                        <p v-show="scope.row.allvaldate.split('~')[0]">{{scope.row.allvaldate.split('~')[0]}}</p>
                        <p>~</p>
                        <p v-show="scope.row.allvaldate.split('~')[1]">{{scope.row.allvaldate.split('~')[1]}}</p>
                      </div>
                      <p v-else class="center">{{scope.row.allvaldate}}</p>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="起始有效期" min-width="120">
                    <template slot-scope="scope">
                        <p class="textHiden">{{scope.row.startvaldate}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="结束有效期" min-width="120">
                    <template slot-scope="scope">
                        <p class="textHiden">{{scope.row.endvaldate}}</p>
                    </template>
                </el-table-column> -->
                <el-table-column label="由流向方发货" min-width="120">
                    <template slot-scope="scope">
                        <p class="textHiden">{{scope.row.bbindflowsendName | empty}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="只可到店提货" min-width="120">
                    <template slot-scope="scope">
                        <p class="textHiden">{{scope.row.isbindstoreName | empty}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="是否支持兑换商城币" min-width="150" v-if="ElementControls('giftCardToMallCoin')==1">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.supportshopcurrencyName">{{scope.row.supportshopcurrencyName}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="可兑换商城币数量" min-width="150" v-if="ElementControls('giftCardToMallCoin')==1">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.shopcurrencynum">{{scope.row.shopcurrencynum}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="实际用途" min-width="120" v-if="ElementControls('giftCardToMallCoin')==1">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.realuseforName">{{scope.row.realuseforName | empty}}</p>
                    </template>
                </el-table-column>
                 <el-table-column label="面单打印备注" min-width="250">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.printmemo">{{scope.row.printmemo | empty}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="客服备注" min-width="250">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.sermemo">{{scope.row.sermemo | empty}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="售卡渠道" min-width="150">
                    <template slot-scope="scope">
                        <span :title="scope.row.channelname">{{scope.row.channelname | empty}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="出库时间" min-width="120">
                    <template slot-scope="scope">
                       {{scope.row.foperdate}}
                    </template>
                </el-table-column>
                <el-table-column label="出库备注" min-width="250">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.sermemo">{{scope.row.memo | empty}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="激活时间" min-width="120">
                    <template slot-scope="scope">
                        {{scope.row.actdate | empty}}
                    </template>
                </el-table-column>
                <el-table-column label="激活备注" min-width="250">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.sermemo">{{scope.row.actmemo | empty}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="最近一次操作时间" min-width="200">
                    <template slot-scope="scope">
                        <p class="textHiden">{{scope.row.upddate}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="最近一次提货订单号" min-width="200">
                    <template slot-scope="scope">
                        <span :title="scope.row.orderno">{{scope.row.orderno | empty}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="订单状态" min-width="120">
                    <template slot-scope="scope">
                        <span :class="[{'greenColor':scope.row.ordstateName=='已发货' || scope.row.ordstateName=='配货中' || scope.row.ordstateName=='部分发货'},{'orangeColor':scope.row.ordstateName=='待处理' || scope.row.ordstateName=='待付款'},{'greyColor':scope.row.ordstateName=='订单取消' },{'redColor':scope.row.ordstateName=='问题结单'||scope.row.ordstateName=='已退款'},{'blueColor': scope.row.ordstateName=='正常结单'},]">{{scope.row.ordstateName}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="订单来源" min-width="120">
                    <template slot-scope="scope">
                        <span :title="scope.row.prosourceName">{{scope.row.prosourceName | empty}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="提货终端" min-width="120">
                    <template slot-scope="scope">
                        <span :title="scope.row.terminaltypeName">{{scope.row.terminaltypeName | empty}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="送货方式" min-width="120">
                    <template slot-scope="scope">
                        <span :class="scope.row.delimodeName=='送货'?'blueColor':'orangeColor'">{{scope.row.delimodeName | empty}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="所属订单内容" min-width="300">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.ordercontent">{{scope.row.ordercontent | empty}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="所属订单商品总额(￥)" min-width="200">
                    <template slot-scope="scope">
                        {{scope.row.allamount | empty}}
                    </template>
                </el-table-column>
                <el-table-column label="买家备注" min-width="300">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.buyermemo">{{scope.row.buyermemo | empty}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="卖家备注" min-width="250">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.sellermemo">{{scope.row.sellermemo | empty}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="订单备注" min-width="250">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.ordermemo">{{scope.row.ordermemo | empty}}</p>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="下单时间" min-width="120">
                    <template slot-scope="scope">
                        <p class="textHiden">{{scope.row.submitdate}}</p>
                    </template>
                </el-table-column> --> 
                <el-table-column label="下单人" min-width="230">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.orderuname">{{scope.row.orderuname | empty}}</p>
                        <small v-show="scope.row.submitdate" :title="scope.row.submitdate">下单时间：{{scope.row.submitdate}}</small>
                    </template>
                </el-table-column>
                <el-table-column label="订单归属" min-width="120">
                    <template slot-scope="scope">
                      <span :title="scope.row.operpowerName">{{scope.row.operpowerName | empty}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="订单归属方" min-width="120">
                    <template slot-scope="scope">
                      <p class="textHiden" :title="scope.row.handlercodeName">{{scope.row.handlercodeName | empty}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="期望发货日期" min-width="200">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.recvdate">{{scope.row.recvdate | empty}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="发货日期" min-width="200">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.deliverdate">{{scope.row.deliverdate | empty}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="收货信息" min-width="400">
                    <template slot-scope="scope">
                        <div v-if="scope.row.receivername || scope.row.receivertel || scope.row.othtel || scope.row.fulladdr">
                          <p class="blackColor">
                            <b v-show="scope.row.receivername" class="iconuser" :title="scope.row.receivername">{{scope.row.receivername}}</b>&nbsp;&nbsp;
                            <b v-show="scope.row.receivertel || scope.row.othtel" class="icongh" :title="scope.row.receivertel?scope.row.receivertel:scope.row.othtel">{{scope.row.receivertel?scope.row.receivertel:scope.row.othtel}}</b>
                          </p>
                          <small class="textFl pdr50" :title="scope.row.fulladdr">{{scope.row.fulladdr | empty}}</small>
                        </div>
                        <p v-else>--</p>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="联系方式" min-width="120">
                    <template slot-scope="scope">
                        <p class="textHiden">{{scope.row.receivertel}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="备用联系方式" min-width="120">
                    <template slot-scope="scope">
                        <p class="textHiden">{{scope.row.othtel}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="收货地址" min-width="300">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.fulladdr">{{scope.row.fulladdr}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="结单日期" min-width="120">
                    <template slot-scope="scope">
                        <p class="textHiden">{{scope.row.enddate}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="结单备注" min-width="300">
                    <template slot-scope="scope">
                        <p class="textHiden" :title="scope.row.endmemo">{{scope.row.endmemo}}</p>
                    </template>
                </el-table-column> -->
                <el-table-column label="结单信息" min-width="250">
                    <template slot-scope="scope">
                        <p v-show="scope.row.endmemo" class="textFl" :title="scope.row.endmemo">{{scope.row.endmemo}}</p>
                        <small v-show="scope.row.enddate" :title="scope.row.enddate">{{scope.row.enddate}}</small>
                        <span v-show="scope.row.endmemo == null && scope.row.enddate==null">--</span>
                    </template>
                </el-table-column>
                <template slot="empty">
                  <div class="noData"><span>暂无数据</span></div>
                </template>
            </el-table>
            <!--E 商品列表-->
        </div>
        <!-- S 分页 -->
        <Page :pageTotal="pagebBean.totalnum" :currentPage="currentPage" @nowPageParam="updatePage"></Page>
        <!-- S 分页 -->
    </section>
    <!-- S 任务列表弹窗 -->
    <TaskList :isStatistics="1" :specMange="specMange" :eleType="0" @closeTask="closeTask"></TaskList>
    <!-- E 任务列表弹窗 -->
    <!--S 归类统计-->
    <el-dialog :visible.sync="groupShow" class="comDlog seniorMdg" append-to-body :close-on-click-modal="false">
        <div slot="title" class="dialog-title">归类统计</div>
        <el-form :model="groupForm" label-width="100px">
            <el-form-item label="归类依据">
                <el-select v-model="groupForm.group" filterable placeholder="请选择或输入" clearable>
                    <el-option
                      v-for="(item,index) in groupList"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                      :title="item.label">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="openGroup(1)">确定</el-button>
            <el-button @click="openGroup(0)">取消</el-button>
        </div>
    </el-dialog>
    <!--E 归类统计-->
    <!-- S 归类统计列表 -->
    <CardClassifyStatistics :classifyValue="groupForm.group" :cateType="0" :queryParams="queryParams" :groupDetailShow="groupDetailShow" @closePop="closeCstatis"></CardClassifyStatistics>
    <!-- E 归类统计列表 -->
    <!-- S 专区商品信息 -->
    <GoodsChoose :goodsChoseDialogVisible="goodsChoseDialogVisible" :isCardCode="cardCode" @closeGoodsPop="closeGoodsChoose"></GoodsChoose>
    <!-- E 专区商品信息 -->
    <!--S 当前组合卡信息 -->
    <el-dialog :visible.sync="viewMoreCardShow" class="comDlog cardMoreInfoDlg" :close-on-click-modal="false" append-to-body>
      <div slot="title" class="dialog-title">券卡规则信息</div>
      <ul class="basicWrap">
        <template v-if="rowInfo.cardcategory === 0 || rowInfo.cardcategory === 1">  
          <li>
            <em>券卡类别：</em>
            <b>
              <el-tag v-if="rowInfo.cardcategory === 0" type="danger" plain>定量组合提货卡</el-tag>
              <el-tag v-if="rowInfo.cardcategory === 1" type="warning" plain>套餐组合提货卡</el-tag>
            </b>
          </li>
          <li>
            <em>可兑换商品总数：</em>
            <b>{{rowInfo.goodspicknum}}</b>
          </li>
          <li>
            <em>剩余可兑换商品数：</em>
            <b class="priceFont greenColor">{{rowInfo.remiangoodspicknum}}</b>
          </li>
          <li>
            <em>单次最少兑换商品数：</em>
            <b>{{rowInfo.minpicknumonce}}</b>
          </li>
          <li>
            <em>最多可提货次数：</em>
            <b>{{rowInfo.usenum}}</b>
          </li>
          <li>
            <em>已提货次数：</em>
            <b  class="priceFont orangeColor">{{rowInfo.usenum - rowInfo.residuenum}}</b>
          </li>
        </template>
        <template v-else>  
          <li>
            <em>券卡类别：</em>
            <b><el-tag type="danger" plain>定额组合提货卡</el-tag></b>
          </li>
          <li>
            <em>最多可提货次数：</em>
            <b>{{rowInfo.usenum}}</b>
          </li>
          <li>
            <em>已提货次数：</em>
            <b class="priceFont orangeColor">{{rowInfo.usenum - rowInfo.residuenum}}</b>
          </li>
          <li>
            <em>券卡额度：</em>
            <b class="priceFont redColor">￥{{rowInfo.cardprice}}</b>
          </li>
          <li>
            <em>剩余可用额度：</em>
            <b class="priceFont greenColor">￥{{rowInfo.remainamount}}</b>
          </li>
          <li>
            <em>补差价金额：</em>
            <b class="priceFont orangeColor">￥{{rowInfo.pricematch}}</b>
          </li>
        </template>
      </ul>
      <div slot="footer" class="dialog-footer">
          <el-button @click="viewMoreCardShow = false">关闭</el-button>
      </div>
    </el-dialog>
    <!--S 当前组合卡信息 -->
  </div>
</template>
<script>
import { MessageBox } from "element-ui";
import api from '@/apis/api.js';
export default {
    name:'CardStatisticsDetail',
    data () {
        return {
            currentTit:0, //当前选中菜单
            highShow: false, //是否展示高级筛选
            groupShow: false,//归类统计弹窗
            searchGLForm:{
                phone:'',
                outTime: [], // 出库时间段
                actTime: [], // 激活时间段
                startTermTime: '', // 券卡过期时间开始
                endTermTime: '', // 券卡过期时间结束
                expectTime: [], // 期望发货时间段
                orderTime: [], // 下单时间段
                startSerial: '', // 开始序列号
                endSerial: '', // 结束序列号
                cardCode: '', // 券卡编码
                cardState: [], // 券卡状态
                cardMedium: [], // 券卡介质
                cardType: '', // 券卡类型
                flowcode: '', // 流向方编号
                defineType: '', // 定义类型
                bbindflowsend: '', // 是否由流向方发货
                isbindstore: '', // 是否只允许到店自提
                prosource: '', // 订单来源
                terminaltype: '', // 终端类型
                delimode: [], // 送货方式
                operpower: '', // 订单归属
                deliverTime: [], // 发货时间段
                supportshopcurrency: '', // 是否支持兑换商城币,0：不支持；1：支持；默认0
                realusefor: '', // 0：券卡提货；1：兑换商城币，默认0
                cardcategory: '', // 券卡类别 0：定量组合提货卡；1：套餐组合提货卡；2：定额组合提货卡；
                ordstate:[],//订单状态
            },
            tableHeight: window.innerHeight*.8, //表格动态高度
            specMange:false, //任务列表弹窗
            groupForm:{
                group:''
            },//归类统计弹窗
            groupList:[
                { value: "state", label: "券卡状态" },
                { value: "cardmedium", label: "券卡介质" },
                { value: "cardkind", label: "券卡类型" },
                { value: "lflowcode", label: "券卡流向" },
                { value: "deftype", label: "定义类型" },
            ],//归类统计
            flowList: [], // 流向方列表
            queryFlowname: '', // 检索的流向名称
            flowCurrent: 1, // 请求的商品的页面
            flowBean: { // 返回的商品分页信息
                totalnum: 0,
            },
            pageSize: 30, // 每页展示的条数
            currentPage: 1, // 当前请求的页数
            pagebBean: {
                totalnum: 0,
            }, // 获取到的列表分页信息
            cardStatisticsList: [], // 券卡统计详情列表
            exportShow: false, // 是否为导出操作
            objtype: 0, // 统计入口
            multipleSelection: [], // 选中的列表数据
            printingShow: true, // 防止多次点击导出按钮
            goodsChoseDialogVisible: false, // 商品弹窗是否显示
            cardCode: '', // 查看商品的券卡编号
            groupDetailShow:false,//归类统计详情弹窗显隐
            queryParams: '', // 归类列表查询参数
            loading: false, // 加载中弹窗显示和隐藏
            mdFlowcode: '', // 登录门店的编号
            viewMoreCardShow:false,//组合卡详细
            rowInfo:{},//当前卡信息
        }
    },
    filters: {
        tjcardStateFilter(val) {
            if (value == 0) {
                return '未激活';
            } else if (value == 1) {
                return '未提货';
            } else if (value == 2) {
                return '部分提货';
            } else if (value == 3) {
                return '已提货';
            } else if (value == 4) {
                return '暂停提货';
            } else if (value == 5) {
                return '已回收';
            } else if (value == 6) {
                return '已作废';
            } else if (value == 7) {
                return '回收折现';
            }
        }
    },
    components: {
        Page: resolve => require(["@/components/common/Page.vue"], resolve),
        TwoDatePicker: resolve => require(["@/components/common/TwoDatePicker.vue"], resolve), // 双日期选择器组件
        GoodsChoose: resolve =>require(["@/components/StatisticsFolder/GoodsChoose.vue"], resolve), // 专区商品信息组件
        TaskList: resolve =>require(["@/components/StatisticsFolder/TaskList.vue"], resolve), // 任务列表组件
        CardClassifyStatistics: resolve =>require(["@/components/StatisticsFolder/CardClassifyStatistics.vue"], resolve), // 归类统计列表组件
        CardState: resolve =>require(["@/components/Gadget/CardState.vue"], resolve), // 券卡状态下拉组件
        DefineType: resolve =>require(["@/components/Gadget/DefineType.vue"], resolve), // 券卡定义类型下拉组件
        OrderState: resolve =>require(["@/components/Gadget/OrderState.vue"], resolve), // 订单状态下拉组件
        OrderSource: resolve =>require(["@/components/Gadget/OrderSource.vue"], resolve), // 订单来源下拉组件
    },
    // ============================================== 监听 ==============================================
    watch: {
        
    },
    // ============================================== 方法 ==============================================
    methods: {
        //打开组合卡规则信息
        viewMoreCard(row){
          this.viewMoreCardShow = true;
          this.rowInfo = row;
        },
        //动态获取表格高度
        getHeight() {
            let tbHeight = this.$refs.gsTable.$el.offsetTop; //顶部检索条件占据的高度
            //console.log('表格距离顶部高度',tbHeight,'可视区高度',window.innerHeight)
            this.tableHeight = window.innerHeight - tbHeight - 130; 
        },
        // 接收选中的出库日期
        outDateReceive(info) {
            if(info&&info.length>0) {
                this.searchGLForm.outTime[0] = info[0];
                this.searchGLForm.outTime[1] = info[1];
            } else {
                this.searchGLForm.outTime = [];
            }
        },
        // 接收选中的激活日期
        actDateReceive(info) {
            if(info&&info.length>0) {
                this.searchGLForm.actTime[0] = info[0];
                this.searchGLForm.actTime[1] = info[1];
            } else {
                this.searchGLForm.actTime = [];
            }
        },
        // 接收选中的期望发货日期
        expectDateReceive(info) {
            if(info&&info.length>0) {
                this.searchGLForm.expectTime[0] = info[0];
                this.searchGLForm.expectTime[1] = info[1];
            } else {
                this.searchGLForm.expectTime = [];
            }
        },
        // 接收选中的发货日期
        deliverDateReceive(info) {
            if(info&&info.length>0) {
                this.searchGLForm.deliverTime[0] = info[0];
                this.searchGLForm.deliverTime[1] = info[1];
            } else {
                this.searchGLForm.deliverTime = [];
            }
        },
        // 接收选中的下单日期
        orderDateReceive(info) {
            if(info&&info.length>0) {
                this.searchGLForm.orderTime[0] = info[0];
                this.searchGLForm.orderTime[1] = info[1];
            } else {
                this.searchGLForm.orderTime = [];
            }
        },
        // 对券卡输入值进行检索
        querySearchAsync(queryString, cb) {
            if(queryString) {
                api.GET_CARDKINDLIST({keyword: queryString}).then(res=>{
                    if(res.data.status == "200") {
                        if(res.data.data) {
                            let dataArr = [];
                            res.data.data.forEach(item => {
                                let valInfo = {
                                value: item
                                }
                                dataArr.push(valInfo);
                            })
                            cb(dataArr);
                        } else {
                            b([]);
                        }
                    } else {
                        cb([]);
                    }
                })
            } else {
                cb([]);
            }
        },
        // 获取流向方列表
        getFlowList(size) {
            let flowParams = {
                isShowSelf: 1,
                keyword: this.queryFlowname,
                pageparam: {
                    pagesize: size?size:30, //每页条数
                    currentpage: this.flowCurrent, //当前页数
                    isnewcomp: 1 //是否需要重新统计页数
                }
            }
            if(this.ElementControls('openTotalSalesMode')==1&&this.ElementControls('erjimendian')!=1) {
                flowParams.flowcode = this.mdFlowcode;
                api.GET_SMALLSTORESFLOWINFO(flowParams).then(res => {
                    if(res.data.status == "200") {
                        if(res.data.data && res.data.data != 'null') {
                            this.flowList = res.data.data;
                        } else {
                            this.flowList = [];
                        }
                        this.flowBean = res.data.pagebean;
                    }
                })
            }else if(this.ElementControls('erjimendian')==1) {
                flowParams.flowcode = this.mdFlowcode;
                flowParams.isOpenTotalSalesMode = this.ElementControls('openTotalSalesMode')==1?true:false;
                api.GET_SECSTORESFLOWINFO(flowParams).then(res => {
                    if(res.data.status == "200") {
                        if(res.data.data && res.data.data != 'null') {
                            this.flowList = res.data.data;
                        } else {
                            this.flowList = [];
                        }
                        this.flowBean = res.data.pagebean;
                    }
                })
            } else {
                api.GET_LISTFLOWINFO(flowParams).then(res => {
                    if(res.data.status == "200") {
                        if(res.data.data && res.data.data != 'null') {
                            this.flowList = res.data.data;
                        } else {
                            this.flowList = [];
                        }
                        this.flowBean = res.data.pagebean;
                    }
                })
            }
        },
        // 规格分页
        flowCurrentChange(val) {
            this.flowCurrent = val;
            this.getFlowList();
        },
        // 搜索规格方法
        filterFlow(item) {
            this.queryFlowname = item;
            this.flowCurrent = 1;
            this.getFlowList();
        },
        // 清除筛选的名称
        closeFlowName() {
            this.queryFlowname = '';
            this.flowCurrent = 1;
            this.getFlowList();
        },
        // 检索的券卡介质
        mediumUpdate(val) {
            if(val.length>1) {
                val.splice(0,1)
            }
            this.querySubmit()
        },
        // 检索的送货方式
        delimodeUpdate(val) {
            if(val.length>1) {
                val.splice(0,1)
            }
            this.querySubmit()
        },
        // 返回请求参数
        returnQueryInfo() {
            let detailParams = {
                phone:this.searchGLForm.phone,
                startdate: this.searchGLForm.outTime.length>0?this.dateTime(this.searchGLForm.outTime[0]):'',
                enddate: this.searchGLForm.outTime.length>0?this.dateTime(this.searchGLForm.outTime[1]):'',
                actstartdate: this.searchGLForm.actTime.length>0?this.dateTime(this.searchGLForm.actTime[0]):'',
                actenddate: this.searchGLForm.actTime.length>0?this.dateTime(this.searchGLForm.actTime[1]):'',
                startvaldate: this.searchGLForm.startTermTime?this.dateTime(this.searchGLForm.startTermTime):'',
                endvaldate: this.searchGLForm.endTermTime?this.dateTime(this.searchGLForm.endTermTime):'',
                startrecvdate: this.searchGLForm.expectTime.length>0?this.dateTime(this.searchGLForm.expectTime[0]):'',
                endrecvdate: this.searchGLForm.expectTime.length>0?this.dateTime(this.searchGLForm.expectTime[1]):'',
                startsubmitdate: this.searchGLForm.orderTime.length>0?this.dateTime(this.searchGLForm.orderTime[0]):'',
                endsubmitdate: this.searchGLForm.orderTime.length>0?this.dateTime(this.searchGLForm.orderTime[1]):'',
                xlhstart: this.searchGLForm.startSerial,
                xlhend: this.searchGLForm.endSerial,
                code: this.searchGLForm.cardCode,
                cardkind: this.searchGLForm.cardType,
                lflowcode: this.searchGLForm.flowcode,
                state: this.searchGLForm.cardState,
                deftype: this.searchGLForm.defineType,
                cardmedium: this.searchGLForm.cardMedium.length>0?this.searchGLForm.cardMedium[0]:'',
                bbindflowsend: this.searchGLForm.bbindflowsend,
                isbindstore: this.searchGLForm.isbindstore,
                prosource: this.searchGLForm.prosource,
                terminaltype: this.searchGLForm.terminaltype,
                delimode: this.searchGLForm.delimode.length>0?this.searchGLForm.delimode[0]:'',
                delstartdate: this.searchGLForm.deliverTime.length>0?this.dateTime(this.searchGLForm.deliverTime[0]):'',
                delenddate: this.searchGLForm.deliverTime.length>0?this.dateTime(this.searchGLForm.deliverTime[1]):'',
                supportshopcurrency: this.searchGLForm.supportshopcurrency,
                realusefor: this.searchGLForm.realusefor,
                // operpower: this.searchGLForm.operpower,
                cardcategory: this.searchGLForm.cardcategory,
                ordstate:this.searchGLForm.ordstate,
            };
            return detailParams;
        },
        // 获取券卡统计详情列表
        getCardstatisticsDetail() {
            this.loading = true;
            let detailParams = this.returnQueryInfo();
            detailParams.pageparam = {
                pagesize: this.pageSize, //每页条数
                currentpage: this.currentPage, //当前页数
                isnewcomp: 1 //是否需要重新统计页数
            }
            api.GET_CARDSTATISTICSDETAIL(detailParams).then(res => {
                this.loading = false;
                if(res.data.status == "200") {
                    if(res.data.data && res.data.data !='null') {
                        this.cardStatisticsList = res.data.data;
                    } else {
                        this.cardStatisticsList = [];
                    }
                    this.pagebBean = res.data.pagebean;
                }
            }).catch(res => {
                this.loading = false;
            })
        },
        // 接收分页信息
        updatePage(size,num) {
            this.pageSize = size;
            this.currentPage = num;
            this.getCardstatisticsDetail();
        },
        // 检索确定事件
        querySubmit() {
            this.currentPage = 1;
            this.getCardstatisticsDetail();
        },
        // 打开归类选择弹窗
        openGroup(type) {
            if(type == 1) {
                if(!this.groupForm.group) {
                    this.$message({
                        type: 'warning',
                        message: '请选择归类依据！'
                    })
                    return false;
                }
                // 获取归类统计列表
                this.queryParams = this.returnQueryInfo();
                this.groupDetailShow = true;
            } else {
                this.groupForm.group = '';
                this.groupShow = false;
            }
        },
        // 导出操作显示
        openExport() {
            this.exportShow = true;
        },
        // 取消导出
        closeExport() {
            this.multipleSelection = [];
            this.$refs.gsTable.clearSelection(); // 清空选中列表数据
            this.exportShow = false;
        },
        // 打印操作确认事件
        toPrinting(type) {
            if(this.printingShow) {
                let queryParams = this.returnQueryInfo();
                queryParams.objtype = Number(this.objtype);
                if(type == 1) {
                    if(this.multipleSelection&&this.multipleSelection.length>0) {
                        queryParams.exceltype = 1;
                        let alltotales = '';
                        this.multipleSelection.forEach(item => {
                            if(alltotales!=='') {
                                alltotales = alltotales + ',' + item.code;
                            } else {
                                alltotales = item.code;
                            }
                        })
                        this.loading = true;
                        this.printingShow = false;
                        queryParams.alltotale = alltotales;
                        this.getUrlForCardstatisticsDetail(queryParams);
                    } else {
                        this.$message({
                            type: 'warning',
                            message: '请至少勾选一项！'
                        })
                    }
                } else {
                    this.loading = true;
                    this.printingShow = false;
                    queryParams.exceltype = 0;
                    this.getUrlForCardstatisticsDetail(queryParams);
                }
            }
        },
        // 获取兑换礼券统计详细列表信息下载地址
        getUrlForCardstatisticsDetail(params) {
            api.GET_URLFORCARDSTATISTICSDETAIL(params).then(res => {
                this.printingShow = true;
                if(res.data.status == "200") {
                    if(res.data.data && res.data.data.indexOf('http')!=-1) {
                        window.location.href = res.data.data;
                        this.$message({
                            type: 'success',
                            message: res.data.message
                        })
                        this.closeExport();
                    } else {
                        MessageBox.confirm(`${res.data.data}`, '提示', {
                            confirmButtonText: '确定',
                            showCancelButton: false,
                            type: 'success'
                        }).then(() => {
                            this.closeExport();
                        }).catch(() => {})
                    }
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.message
                    })
                }
                this.loading = false;
            }).catch(res => {
                this.loading = false;
                this.printingShow = true;
            })
        },
        //表格多选选中行复制
        handleSelectionChange(val) { 
            this.multipleSelection = val;
        },
        // 查看券卡专区信息
        seeGoodsInfo(code) {
            this.cardCode = code;
            this.goodsChoseDialogVisible = true;
        },
        // 关闭商品弹窗
        closeGoodsChoose() {
            this.cardCode = '';
            this.goodsChoseDialogVisible = false;
        },
        // 关闭任务列表弹窗
        closeTask() {
            this.specMange = false;
        },
        // 关闭归类统计列表
        closeCstatis() {
            this.groupForm.group = '';
            this.groupShow = false;
            this.groupDetailShow = false;
        },
        // 获取券卡状态的值
        cardStateObtain(val) {
            this.searchGLForm.cardState = val;
        },
        // 获取券卡定义类型的值
        defineTypeObtain(val) {
            this.searchGLForm.defineType = val;
        },
        // 接收选中的订单状态
        orderStatusObtain(val) {
            this.searchGLForm.ordstate = val;
        },
        // 接收选中的订单来源
        orderSourceObtain(val) {
            this.searchGLForm.prosource = val;
        },
    },
    created() {
        //页面浏览器视窗变化绑定resize事件
        window.addEventListener("resize", this.getHeight);
    },
    mounted () {
        if(localStorage.getItem('userInfoMd')) {
            this.mdFlowcode = JSON.parse(localStorage.getItem('userInfoMd')).flowcode;
        }
        let startDate = new Date();
        let endDate = new Date();
        startDate.setTime(startDate.getTime() - 3600 * 1000 * 24 * 365);
        if(sessionStorage.getItem('ticsQueryInfo')&&sessionStorage.getItem('ticsQueryInfo')!=undefined) {
            let ticsQueryInfo = JSON.parse(sessionStorage.getItem('ticsQueryInfo'));
            if(ticsQueryInfo.flowcode!=undefined&&ticsQueryInfo.flowcode!=-1) {
                this.searchGLForm.flowcode = ticsQueryInfo.flowcode;
            }
            if(ticsQueryInfo.cardmedium!=undefined&&ticsQueryInfo.cardmedium!=='') {
                this.searchGLForm.cardMedium.push(ticsQueryInfo.cardmedium);
            }
            setTimeout(() => {
                if(ticsQueryInfo.eleType!=undefined&&ticsQueryInfo.eleType!=-1) {
                    this.searchGLForm.cardState.push(ticsQueryInfo.eleType);
                }
                if(this.objtype=='7'&&ticsQueryInfo.eleType==-1) {
                    this.searchGLForm.cardState = [1,3,4];
                }
                this.searchGLForm.outTime = ticsQueryInfo.paiTime!=undefined?(ticsQueryInfo.paiTime.length>0?ticsQueryInfo.paiTime:[startDate,endDate]):[startDate,endDate];
                this.searchGLForm.actTime = ticsQueryInfo.actTime!=undefined?ticsQueryInfo.actTime:[];
            }, 305);
        };
        if(this.$route.query.objtype!==undefined) {
            this.objtype = this.$route.query.objtype;
        }
        setTimeout(() => {
            this.getCardstatisticsDetail();
            this.getFlowList(10000);
        }, 310);
        //在dom渲染之后
        setTimeout(()=>{
            this.getHeight();
        },200)

    },
    computed: {},
    destroyed(){ 
        window.removeEventListener('resize', this.getHeight); //销毁监听浏览器视窗变化
    }
}
</script>
<style scoped>
@import '../../GoodsFolder/Css/style.css';
.goodsBox {padding:20px; height:calc(100% - 40px);}
.gsTable em{
    display: inline-block;
    vertical-align: middle;
    height: 20px;
    width: 20px;
    color:
    #fff;
    border-radius: 50%;
    text-align: center;
    font-size: 12px;
    line-height: 20px;
    margin-left: 10px;
}
.gsTable .orange{background-color: #FF7018;}
.gsTable .blue{background-color: var(--main-color);}
.gsTable .iconhand::before {
    font-size: 20px;
    padding-right: 5px;
    display: inline-block;
    vertical-align: top;
}
.gsTable >>> .el-table__header .el-form-item {margin-bottom:0!important;}
.goodsUse {position:relative;height:36px;padding-right:15px;border-right:solid 1px #dcdfe6;}
.goodsUse em {position:absolute; left:0; top:-20px; font-size: 12px; color:#999;}
.gsTable.el-table >>> thead.is-group > tr:first-child th .cell{overflow: visible!important;}
.gsTable.el-table >>> thead.is-group > tr:nth-child(2) th .cell {color:#333;}
.gsTable.el-table >>> .el-table__body .el-checkbox {padding:20px;}
.gsTable.el-table >>> .el-table__header .el-checkbox {padding:0 20px;}
.gsTable >>> .el-dropdown-link {cursor: pointer; color: var(--main-color);}
.inlineMember {padding:0 10px; border:solid 1px #dcdfe6; height:38px; line-height:38px;}
.childView.takeLeft .inlineMember,.childView.helpRight .inlineMember {margin-top:0px;}
@media only screen and (max-width: 1700px) {
  .inlineMember {margin-top:10px;} 
}
.inlineMember a:first-child {position:relative; width:30px; height:30px; margin:3px 0; border-radius:50%; overflow: hidden; border:solid 1px #ebeef5; }
.inlineMember img {position:absolute; left:0; top:0; right:0; bottom:0; margin:auto; width:30px; }
.inlineMember * {display:inline-block; vertical-align: top; font-size: 14px;}
.inlineMember span {margin-right:10px;}
.inlineMember i {color:#999;}
.inlineMember em {max-width:150px; width: auto;}
.inlineMember .iconmale {font-size: 18px;color:var(--main-color);}
.inlineMember .iconfemale {font-size: 18px;color:#f56c6c;}
.goodsImg{
  display: inline-block;
  position: relative;
  width: 50px;
  height: 50px;
  border: solid 1px #dcdfe6;
  border-radius:100%;
  margin-right:10px;
}
.goodsImg img {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  max-width: 100%;
  border-radius: 50%;
}
.goodsCont h3{font-size:14px!important;font-weight:bold;}
.goodsCont p{font-size:12px;}
.goodsCont{width: calc(100% - 65px);}
.actShow {padding-top:10px; color:#999;  font-size: 12px;}
.actShow span {display:inline-block; margin-right:35px;}
.actShow span b {font-weight: 600; padding-right:5px;}
/*归类统计弹窗*/
.seniorMdg >>> .el-dialog {width:500px;}
.seniorMdg >>> .el-form-item__content {width:65%; min-width: 200px; max-width: 340px;}
.seniorMdg >>> .el-form-item__content .el-select {width:100%;}
.none{display: none;}
.block{display: block;}
.center{text-align: center;}

/*组合卡信息 */
.cardMoreInfoDlg>>> .el-dialog {width:500px;}
.cardMoreInfoDlg >>> .el-dialog__body{display: flex;justify-content: center;}
.cardMoreInfoDlg .basicWrap {min-width: 60%;}
</style>



// WEBPACK FOOTER //
// src/views/StatisticsFolder/CardStatistics/CardStatisticsDetail.vue